__webpack_require__.p = "https://nbbrl-res.jlzsjc.com/frontend/demo/gaming-platform-brl-h5/";